export default (function (feedbackState) {
  var defaultToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

  if (typeof feedbackState === 'string') {
    return "colors/text/".concat(feedbackState);
  }

  return "colors/text/".concat(feedbackState.error && 'error' || feedbackState.warning && 'warning' || feedbackState.success && 'success' || feedbackState.inverse && 'inverse' || feedbackState['inverse-on-background'] && 'inverse-on-background' || feedbackState.neutral && 'neutral' || defaultToken);
});
//# sourceMappingURL=index.js.map